import { BugTracker, SignalError } from "../../library";
import { useEffect, useState } from "react";

import Configuration from "../../configuration/general.json";
import { Headers } from "../../types";
import useUser from "../store/useUser";

enum State {
  Storage = "storage",
  Url = "url",
}

const useAuth = (headers: Headers) => {
  const [token, setToken] = useState<string | undefined>(undefined);
  const [error, setError] = useState<SignalError | undefined>(undefined);

  const { storeUser, removeUser } = useUser();

  useEffect(() => {
    const sesToken = headers?.Authorization?.split(" ")[1];
    setToken(sesToken);
    storeUser({ sessionToken: sesToken });
  }, [headers?.Authorization]);

  const logout = async () => {
    removeUser();

    try {
      if (headers) {
        await fetch(`${Configuration.apiBaseUrl}/logout`, {
          headers,
          method: "DELETE",
        });
      }
    } catch (err) {
      setError(err);
      BugTracker.captureException(err);
      console.log(`LOGOUT ERROR: ${err.message}`);
    }

    const logoutUrl = (() => {
      const u = new URL(window.location.href);
      u.hash = "#/logout";
      return u.toString();
    })();

    window.location.href = `${
      Configuration.auth0DomainCom
    }/logout?returnTo=${encodeURIComponent(logoutUrl)}`;
  };

  return { token, error, logout };
};

export default useAuth;
